require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-does-the-world-banks-new-corporate-scorecard-raise.json") })
        }
      }, "path---en-us-update-does-the-world-banks-new-corporate-scorecard-raise");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-does-the-world-banks-new-corporate-scorecard-raise!./.cache/json/en-us-update-does-the-world-banks-new-corporate-scorecard-raise.json
// module id = 659
// module chunks = 231608221292675